const tableCls = "_n29t1hm5b68";
const tableBodyCls = "_n29t1m38z9i";
const rowCls = "_n29r8mkrei";
const cellCls = "_n29c1ifen5s";
const cellFontSizeSmallCls = "_n29c1tbfnng";
const cellFontSizeMediumCls = "_n29c1qfpavz";
const cellFontSizeLargeCls = "_n29c1vjh6ml";
const cellFontSizeExtraLargeCls = "_n29c16xqhwx";

export { cellCls, cellFontSizeExtraLargeCls, cellFontSizeLargeCls, cellFontSizeMediumCls, cellFontSizeSmallCls, rowCls, tableBodyCls, tableCls };
import "./Table.style.linaria.module.css";
//# sourceMappingURL=Table.style.js.map
